import React from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { injectIntl } from 'react-intl'
import PropTypes from 'prop-types'
import Spinner from '../../util/spinner-shim'

import AppButton from '../partials/Navigation/AppButton'
import Footer from '../partials/Footer'
import NavigationBar from '../partials/NavigationBar'
import withAppStore from '../../util/withAppStore'

import styles from '../../../css/home.module.css'
import stylesDevice from '../../../css/devicePage.module.css'

import AppStore from '../../stores/AppStore'
import AppDispatcher from '../../dispatchers/AppDispatcher'

const stringifyGroup = (a) => `${a.name}|${a.deviceGroup || ''}|${a.icon}`

function CustomerDeviceGroupsPage (props) {
  const navigate = useNavigate()
  const { customerID } = useParams()

  const getCustomer = React.useCallback(() => {
    AppDispatcher.dispatch({
      action: 'get-customer',
      customerID,
    })
  }, [customerID])

  const goBack = React.useCallback(() => navigate('/settings'), [])

  React.useEffect(() => {
    getCustomer()
  }, [getCustomer])

  const {
    auth: {
      logout,
    },
    intl: {
      formatMessage,
    },
    pages: {
      CustomerDeviceGroupsPage: title,
    },
    route: {
      path,
    },
  } = props

  const {
    applications: groups,
  } = AppStore.getCustomer()

  let groupsButtons

  if (groups && groups.length) {
    groupsButtons = groups
      .sort((a, b) => (stringifyGroup(a)).localeCompare(stringifyGroup(b)))
      .map(group => (
        <AppButton
          icon={group.icon}
          key={stringifyGroup(group)}
          label={group.name || group.deviceGroup}
          link={`groups/${group.groupID}`}
        />
      ))
  } else {
    groupsButtons = [(
      <Spinner
        key='spinner'
        name='double-bounce'
        style={{ width: '30px', marginLeft: 'auto', marginRight: 'auto' }}
      />
    )]
  }

  const DEVICE_GROUPS = formatMessage({
    id: 'general.device.groups',
    defaultMessage: 'Device Groups'
  })

  const NEW_GROUP = formatMessage({
    id: 'general.new.group',
    defaultMessage: 'New Group',
  })

  return (
    <div>
      <Helmet><title>{title}</title></Helmet>
      <NavigationBar
        page={path}
        logOut={() => logout(navigate)}
        backFunc={goBack}
        name={DEVICE_GROUPS}
      />
      <div className={styles.pageWidth}>
        <div className={styles.pageContainer}>
          <Link
            activeStyle={{ overflowWrap: 'break-word' }}
            to={`/${customerID}/settings/deviceGroups/add`}
            className={stylesDevice.settingButtonCustomer}
          >
            <section
              className={`${styles.userSection} h3 ${styles.userSectionEdit}`}
              key='user-invite'
            >
              <div style={{ textAlign: 'center', margin: '23px 0px' }}>
                <i className='fa fa-plus' style={{ marginRight: '1em', fontSize: '20px' }} />
                {NEW_GROUP}
              </div>
            </section>
          </Link>
          <div className={styles.list}>
            {groupsButtons}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

CustomerDeviceGroupsPage.propTypes = {
  pages: PropTypes.object,
  data: PropTypes.object,
  auth: PropTypes.object,
  intl: PropTypes.object,
  route: PropTypes.object,
}

export default withAppStore(injectIntl(CustomerDeviceGroupsPage))
